export class RequestVM {
  userName: string | undefined;
  currentPassword: string | undefined;
  newPassword: string | undefined;
  isSelectedPhoneNumber: boolean | undefined;
  mobilePhone: string | undefined;
  mail: string | undefined;
  constructor(userName: string | undefined, currentPassword: string | undefined, newPassword: string | undefined, isSelectedPhoneNumber: boolean | undefined, mobilePhone: string | undefined, mail: string | undefined) {
    this.userName = userName;
    this.currentPassword = currentPassword;
    this.newPassword = newPassword;
    this.isSelectedPhoneNumber = isSelectedPhoneNumber;    
    this.mobilePhone = mobilePhone;
    this.mail = mail;
  }
}